import { useIdStore } from '@mentimeter/core-hooks/use-ids';

export const setSeriesIdForIdStore = (seriesId: string) => {
  useIdStore.getState().setSeriesId(seriesId);
};

export const setQuestionIdForIdStore = (questionId: string | undefined) => {
  useIdStore.getState().setQuestionId(questionId);
};
